var Aneox;
(function(Aneox) {
  'use strict';

  var App = (function() {

    var self;

    var oldNodeId;
    var oldNodeType;
    var currentNodeId;
    var currentKeyframeId;
    var currentNodeType;
    var flagDataLoaded = 0;
    var flagImgLoaded = 0;
    var firstLocalChange = true;
    
    var isTouchDevice;

    var ageCheckPopupVisible = true;

    function App(fonts, locale, router, analytics,
     animations, scroll, menu, wines, vintages, distributors, galleries) {
      this.fonts = fonts;
      this.locale = locale;
      this.router = router;
      this.analytics = analytics;

      this.animations = animations;
      this.scroll = scroll;
      this.menu = menu;
      this.wines = wines;
      this.vintages = vintages;
      this.distributors = distributors;
      this.galleries = galleries;

      self = this;
      self.dataVintages = [];
      self.dataWhiteWines;
      self.dataRedWines;
      self.dataCountries;
      self.dataImport;
      self.dateGaleriePresentation;
      self.dataGalerieSavoirfaire;
      self.dataGalerie = [];    
      self.dataAllWines = [];
      self.dataAllWinesRaw = {};

      var md = new MobileDetect(window.navigator.userAgent);
      Aneox.Data.Config.runtime = {
        isTouchDevice: 'ontouchstart' in document.documentElement,
        mobile: md.mobile(),
        supportsScrollEvents: !md.mobile() || (md.is('iOS') && md.is('Safari') && md.version('Safari') > 8)
      };

      // Quick and dirty desktop/mobile check
      if (screen && screen.availWidth < 1024) window.location.href = 'http://mobile.chavy-chouet.com';

      // set heights
      $('[data-height]').each(function() {
        var el = $(this);
        el.innerHeight(el.data('height'));
      });

      $(document).on("dataLoaded", initiate);    


      // age check overlay
      this.scroll.resetScrollRetainCount();
      if ($.cookie('agecheck') === 'true') {
        $('#age-check').remove();
        ageCheckPopupVisible = false;
      } else {
        $('#age-check').show();
        this.scroll.incrementScrollRetainCount();
      }



      (function() {
        var now = new Date();
        now.setFullYear(now.getFullYear() - 18);
        var nowText = now.toISOString().substring(0, 10).split('-');
        $('#age-check-date').text(nowText[2] + '/' + nowText[1] + '/' + nowText[0]);
      }) ();

      // don't show outlines on mousedown
      $("body").on("mousedown", "button, a, input", function(e) {
        $(this).css("outline", "none").on("blur", function() {
          $(this).off("blur").css("outline", "");
        });
      });

      // disable elements with "disabled" attribute
      $(document).on('click keydown', '[disabled]', function(event) {
        event.preventDefault();
      });

      this.router.bind('pageChange', function (path, node, nodeLocale) {

        oldNodeId = currentNodeId;
        oldNodeType = currentNodeType;

        currentNodeId = node.id;
        currentKeyframeId = node.id;
        currentNodeType = node.type;

        if (currentNodeType === 'wine-page' && self.animations.sequences) {
          self.wines.openPage(node.id);
          return;
        }

        if (currentNodeType === 'legal') {
          self.locale.setLocale(nodeLocale.locale);
          self.openLegal();
          return;
        }

        if (currentNodeType === 'basic-page') {
          $('.menu-link.active').removeClass('active');
          $('#menu-link-' + getSequenceId(currentNodeId)).addClass('active');
        }

        self.locale.setLocale(nodeLocale.locale);

        if (self.scroll.isManual()) {
          self.scroll.cancelManualScroll();
          return;
        }

        if (self.animations.sequences) {
          var time;

          if (oldNodeType === 'wine-page') {
            time = self.animations.sequences.main.keyframes['wine-list'];
          } else {
            time = self.animations.sequences.main.keyframes[currentKeyframeId] || 0;
          }
          
          self.scroll.incrementScrollRetainCount(false);

          self.animations.enabled = false;
          resetAnimations();

          self.animations.sequences.main.setTime(time);
          self.scroll.lastScrollAction('pageChange');

          self.animations.enabled = true;
          if (!ageCheckPopupVisible) {
            getEnterAnimation(currentKeyframeId)();
          }

          self.scroll.decrementScrollRetainCount();
        }
      });

      this.locale.bind('localeChange', function (locale) {

        $('[router-locale]').removeClass('active')
        .filter('[router-locale=' + locale + ']').addClass('active');

        $('[data-alt]').each(function() {
          $(this).attr('alt', _.find(Aneox.Data.Data.texts, { id: $(this).data('alt') })[locale]);
        });
        $('[data-title]').each(function() {
          $(this).attr('title', _.find(Aneox.Data.Data.texts, { id: $(this).data('title') })[locale]);
        });

        $('a[href^=http]').attr('target', '_blank');

        setData(locale);



        handleWindowResize();
      });


      function setData(locale){
        self.vintages.populateInlineSection(locale);
        self.wines.setWinesList(locale);
        self.distributors.appendDataList(locale);

        self.router.reparseAnchors();
      }    

      function initiate(event){

        if(event.type === "dataLoaded" && flagDataLoaded == 0){

          var tempDataWines = _.partition(self.dataAllWinesRaw, function(a){
            return a.nid == a.localeNid;
          });
          
          _.forEach(tempDataWines[0], function(wine){
            Aneox.Data.Nodes.nodes.push({
              id: wine.nid,
              type: 'wine-page',
              locales: [{
                locale: wine.locale,
                description: wine.name+' : '+wine.tasting,
                path: '/vins/' +  _.kebabCase(wine.name),
                title: 'Domaine Chavy-Chouet : '+ wine.name
              }]
            });
          });
          
          _.forEach(tempDataWines[1], function(wine){
            var node = _.find(Aneox.Data.Nodes.nodes,{'id': wine.localeNid});

            if(!_.isEmpty(node)){
             node.locales.push({
              locale: wine.locale,
              description: wine.name+' : '+wine.tasting,
              path: '/wines/' + _.kebabCase(wine.name),
              title: 'Domaine Chavy-Chouet : '+ wine.name
            }); 
           }
         });

          setData(self.locale.getLocale());
          
          flagDataLoaded = 1;
        }

        if(event.type === "imgLoaded" && flagImgLoaded == 0){
         flagImgLoaded = 1;
       }


       if(flagDataLoaded == 1 && flagImgLoaded == 1){

        self.router.init();

        self.animations.enterSite();

        self.router.reparseAnchors();

        resetAnimations(true);

        var node = self.router.getNode();

        handleWindowResize();
        lazySizesConfig.preloadAfterLoad = true;

        setTimeout(function() {
          if (node.id === 'domain') {
            $('#domain-1').show();
          }
          TweenMax.to('#preloader', .5, { opacity: 0, display: 'none', delay: 1 });
          switch(node.type) {
            case 'basic-page':
            var currentKeyframeId = node.id;
            var time = self.animations.sequences.main.keyframes[currentKeyframeId] || 0;
            self.animations.sequences.main.setTime(time);
            self.scroll.lastScrollAction('pageChange');
            if (!ageCheckPopupVisible) {
              self.animations.sequences[getSequenceId(currentKeyframeId)].resetAnimations();
              setTimeout(getEnterAnimation(currentKeyframeId), 1100);
            }
            break;
            case 'wine-page':
            self.animations.sequences.main.setTime(self.animations.sequences.main.keyframes['wine-list']);
            self.wines.openPage(node.id);
          }
        }, 0);

        var throttledWindowResizeHandler = _.throttle(handleWindowResize, 500, {leading: false, trailing: true});
        $(window).resize(throttledWindowResizeHandler);

      }

    }    


    self.animations.bind('complete', function(event){
      initiate(event);
    });    



        // Window resize handling
        var handleWindowResize = function () {
          var bodyWidth = document.body.clientWidth;
          var bodyHeight = document.body.clientHeight;

          var screenWidth = _.get(window, 'screen.width', 0);
          var screenHeight = _.get(window, 'screen.height', 0);
          var maxScreenSize = Math.max(screenWidth, screenHeight);
          var screenOrientation = _.get(window, 'orientation', 0);
          var isPortrait = screenOrientation === 0 || screenOrientation === 180 || screenOrientation === -180;
        //console.log("resize : " + Aneox.Data.Config.runtime.mobile+"--"+maxScreenSize+"--"+isPortrait);
        if (Aneox.Data.Config.runtime.mobile && (maxScreenSize <= 768 || (isPortrait && screenWidth <= 768))) {
          window.location.href = window.location.host.indexOf('chavy-chouet.com') === -1 ? '/mobile.chavy-chouet.com/' : 'http://mobile.chavy-chouet.com/';
        }


        _.forEach(self.animations.sequences, function (sequence) { sequence.handleWindowResize(bodyWidth, bodyHeight); });
        self.animations.handleWindowResize(bodyWidth, bodyHeight);
        self.wines.handleWindowResize(bodyWidth, bodyHeight);
        self.menu.handleWindowResize(bodyWidth, bodyHeight);
        self.galleries.handleWindowResize(bodyWidth, bodyHeight);

        $('.full-height').innerHeight(bodyHeight);

        self.scroll.lastScrollAction('windowResize');
      };    


      var getData = function(){
        var basePath = $('head base').attr('href');

        $.get('api/views/liste_millesimes.json?display_id=services_1', function(data){

          var tmpDataVintages = data.map(function(a){
            return{
              "nid": a.nid,
              "vintages": a.vintages,
              "summary": a.summary,
              "text": a.text,
              "img": a.img,
              "imgpdf": a.imgpdf,
              "localeNid": a.localenid,
              "locale": a.locale
            }
          });


          tmpDataVintages.forEach(function(vintage){

            if(vintage.locale == "fr"){
              var currentVintage  = vintage;

              var enVintage = _.find(tmpDataVintages, function(el){
                if(el.localeNid == vintage.nid && el.nid != vintage.nid){
                  return el;
                }
              });

              self.dataVintages.push({id: currentVintage.nid, name: currentVintage.vintages,img: currentVintage.img, imgpdf: currentVintage.imgpdf , locales: [currentVintage,enVintage]});    
            }

          });


          $.get('api/views/liste_vins_blanc.json?display_id=services_1', function(data){

            self.dataWhiteWines = data.map(function(a){
              return{
                "nid": a.nid,
                "name": a.name,
                "type": _.parseInt(a.type),
                "grape": a.grape,
                "density": a.density,
                "village": a.village,
                "ageing": a.ageing,
                "niveau": a.niveau,
                "tasting": a.tasting,
                "soil": a.soil,
                "surface": a.surface,
                "age": a.age,
                "img": a.img,
                "localeNid": a.localenid,
                "locale": a.locale,
                "cremant": a.cremant,
                "imgpdf": a.imgpdf
              }
            });

            $.get('api/views/liste_vins_rouge.json?display_id=services_1', function(data){

              self.dataRedWines = data.map(function(a){

                return{
                  "nid": a.nid,
                  "name": a.name,
                  "type": _.parseInt(a.type),
                  "grape": a.grape,
                  "density": a.density,
                  "village": a.village,
                  "ageing": a.ageing,
                  "niveau": a.niveau,
                  "tasting": a.tasting,
                  "soil": a.soil,
                  "surface": a.surface,
                  "age": a.age,
                  "img": a.img,
                  "localeNid": a.localenid,
                  "locale": a.locale,
                  "cremant": a.cremant,
                  "imgpdf": a.imgpdf
                }
              });
              $.get('api/views/liste_continents_pays.json?display_id=services_1', function(data){

               self.dataCountries = data.map(function(a){
                return{
                  "name": a.name,
                  "tid": _.parseInt(a.tid),
                  "parentTid": _.parseInt(a.parent_tid),
                  "localeEn": a.localeen,
                  "img": a.img 
                }
              });

               $.get('api/views/liste_importateurs.json?display_id=services_1', function(data){

                self.dataImport = data.map(function(a){
                  return{
                    "nid": a.nid,
                    "name": a.name,
                    "address": a.address,
                    "tel": a.tel,
                    "fax": a.fax,
                    "email": a.email,
                    "website": a.website,
                    "countries": _.parseInt(a.countries)
                  }
                });


                $.get('api/views/galerie_savoir_faire.json?display_id=services_1', function(data){


                  var dataGalerieSavoirfaire = data.map(function(a){
                    return{
                      "img": a.img
                    }
                  });

                  self.dataGalerie.push({id: "savoir-faire", slides: dataGalerieSavoirfaire});

                  $.get('api/views/galerie_presentation.json?display_id=services_1', function(data){

                    var dataGaleriePresentation = data.map(function(a){
                      return{
                        "img": a.img
                      }
                    });

                    self.dataGalerie.push({id: "domain", slides: dataGaleriePresentation});

                    var tmpDataAllWines = _.uniq(_.union(self.dataRedWines, self.dataWhiteWines), "nid"); 

                    self.dataAllWinesRaw = tmpDataAllWines;

                    tmpDataAllWines.forEach(function(wine){

                      if(wine.locale == "fr"){
                                            //var currentWine = 
                                            
                                            //var enWine = _.find(tmpDataAllWines, {"localeNid": wine.nid});
                                            
                                            var enWine = _.find(tmpDataAllWines, function(el){
                                              if(el.localeNid == wine.nid && el.nid != wine.nid){
                                                return el;
                                              }
                                            });
                                            
                                            self.dataAllWines.push({id: wine.nid, name: wine.name,img: wine.img , locales: [wine,enWine]})
                                          }

                                        });

                    $(document).trigger('dataLoaded');

                  });

                });

              });
             });
            });
});

});
}

getData();

}

App.prototype.ageCheckResult = function (result) {
  if (!result) return;

  ageCheckPopupVisible = false;

  $.cookie('agecheck', 'true');
  TweenMax.to('#age-check', .5, { opacity: 0, onComplete: function () {
    $('#age-check').remove();
    resetAnimations();
    self.animations.enabled = true;
    getEnterAnimation(currentKeyframeId)();
    self.scroll.decrementScrollRetainCount();
  } 
});
};

App.prototype.scrollTo = function(scrollTime) {
  self.animations.sequences.main.setTime(scrollTime, 1.5);
  self.scroll.lastScrollAction('scrollToKeyframe');
};

var legalPage = $('#legal');
var legalText = $('#legal-text');

App.prototype.openLegal = function() {
  self.scroll.incrementScrollRetainCount();
  self.animations.openOverlay(legalPage);
  legalText.mCustomScrollbar({
    scrollbarPosition: 'outside',
    scrollButtons: {
      enable: true,
      scrollType: 'stepped',
      scrollAmount: 200
    },
    callbacks: {
      onInit: function() {
        $(this).find('.mCSB_buttonUp').addClass('disabled');
      },
      onScroll: function() {
        if (this.mcs.topPct === 0) {
          $(this).find('.mCSB_buttonUp').addClass('disabled');
          $(this).find('.mCSB_buttonDown').removeClass('disabled');
        } else if (this.mcs.topPct === 100) {
          $(this).find('.mCSB_buttonDown').addClass('disabled');
          $(this).find('.mCSB_buttonUp').removeClass('disabled');
        } else {
          $(this).find('.mCSB_buttonUp, .mCSB_buttonDown').removeClass('disabled')
        }
      }
    }
  });
}

App.prototype.closeLegal = function() {
  self.animations.closeOverlay(legalPage);
  legalText.mCustomScrollbar('destroy');
  self.scroll.decrementScrollRetainCount();

  var nodeId = oldNodeId || 'home';
  var path = self.router.getNodePath(nodeId, self.locale.getLocale());
  self.router.setPath(path);
}

var resetAnimations = function (firstTime) {
  if (self.animations.orderedSequences === undefined) return;

  var i;
  var sequence;

  var activeSequenceIndex = _.indexOf(
    self.animations.orderedSequences,
    self.animations.sequences[getSequenceId(currentKeyframeId)]
    );

  for (i = 0; i < activeSequenceIndex; i++) {
    sequence = self.animations.orderedSequences[i];
    if (sequence.fastForwardAnimations) sequence.fastForwardAnimations();
  }

  if (!firstTime) i++;

  for (i; i < self.animations.orderedSequences.length; i++) {
    sequence = self.animations.orderedSequences[i];
    if (sequence.resetAnimations) sequence.resetAnimations();
  }
};

function getEnterAnimation(keyframeId) {
  switch (keyframeId) {
    case 'home':
    return self.animations.sequences.domain.mastEnterAnimation;
    case 'domain-presentation':
    return self.animations.sequences.domain.presentationEnterAnimation;
    case 'domain-philosophy':
    return self.animations.sequences.domain.philosophyEnterAnimation;
    case 'savoir-faire-viticulture':
    return self.animations.sequences['savoir-faire'].mastEnterAnimation;
    case 'savoir-faire-vinification':
    return self.animations.sequences['savoir-faire'].vinificationEnterAnimation;
    default:
    return self.animations.sequences[keyframeId].mastEnterAnimation;
  }
}

function getSequenceId(keyframeId) {
  switch (keyframeId) {
    case 'home':
    case 'domain-presentation':
    case 'domain-philosophy':
    return 'domain';
    case 'savoir-faire-viticulture':
    case 'savoir-faire-vinification':
    return 'savoir-faire';
    default:
    return keyframeId;
  }
}

return App;
}) ();

Aneox.App = App;
}) (Aneox || (Aneox = {}));